import React from 'react'
import { Row, Col } from 'reactstrap'

import { LineChart } from 'react-chartkick'
import 'chart.js'

const TagMeasurements = ({ data }) => {
  const keys = Object.keys(data)
  console.log('keys', data, Object.keys(data))

  return (
    <Row>
      {keys.map((key, i) => (
        <Col xs={12} md={6} key={i}>
          <h3>{key}</h3>
          <div className="chartcontainer">
            <LineChart
              data={data[key]}
              min={null}
              label={key}
              height="150px"
              library={{
                scales: {
                  xAxes: [{
                    time: {
                      tooltipFormat: 'ddd DD.MM.YYYY'
                    }
                  }],
                  yAxes: [{
                    gridLines: {
                      display: false
                    }
                  }]
                }
              }}
            />
          </div>
        </Col>
      ))}
    </Row>
  )
}

export default TagMeasurements